import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Option } from 'src/app/core/interfaces/option.interface';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  styleUrl: './input-group.component.scss'
})
export class InputGroupComponent implements OnInit {
  @Input({ required: true }) textControl!: FormControl;
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: false }) errorMessage?: string;
  @Input({ required: false }) type: "text" | "number" | "password";

  @Input({ required: true }) selectControl!: FormControl;
  @Input({ required: true }) options!: Option[];

  @Input() appendTo = '';

  currentBindLabel: string;
  value: any;

  getLabel = () => {
    this.currentBindLabel = this.localaztionService.getCachedLanguage() === 'ar' ? 'labelAr' : 'labelEn';
  }

  isTextControlValid(): boolean {
    const control = this.textControl;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  isSelectControlValid(): boolean {
    const control = this.selectControl;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  isValid(): boolean {
    return this.isTextControlValid() && this.isSelectControlValid();
  }

  onValueChange(value: any): void {
    this.selectControl.setValue(value);
  }

  ngOnInit(): void {
    this.getLabel();
  }

  constructor(private localaztionService: LocalizationService) { }
}
